//tslint:disable:export-name
export { RatingsReviewsService } from './service-setup/RatingsReviewsService';
import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.ratingsReviewsService).register();
